import React from "react";
import { useSelector } from "react-redux";

import * as S from "./styles";

import Burger from "./Burger";
import { IState } from "../../app-state/reducer";
import { MainLogo } from "../../pages/UserSession/MainLogo";

type Props = {
    children?: any;
};

export default function Navbar(props: Props) {
    const session = useSelector<IState>((state) => state.session);

    if (!session) return null;

    return (
        <S.ContainerFade>
            <MainLogo baseHeight={7} isHeaderIcon />
            <Burger />
            {props.children}
        </S.ContainerFade>
    );
}
